import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5796a18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media" }
const _hoisted_2 = { class: "page-path path-links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = { class: "filters" }
const _hoisted_7 = { class: "filters" }
const _hoisted_8 = ["onClick"]

import { RootState } from '@/store';
import movieAll, { State } from '@/store/movies/all';
import { ViewContext } from '@/views';
import Pagination from '@/views/components/Pagination.vue';
import { computed, inject, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import TextAlbum from '../hot/TextAlbum.vue';
import Album from './Album.vue';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const context = inject('context') as ViewContext;
const store = useStore();
const rootData = computed<RootState>(() => store.state)
const data = computed<State>(() => store.state[movieAll.name])
const list = computed(() => data.value.albums.slice(0, data.value.pageSize))

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])

const container = ref<HTMLDivElement>()

onMounted(() => {
    window.onresize = onResize;
    onResize();
})

onBeforeUnmount(() => {
    window.onresize = null
})

function onResize() {
    let rect = container.value?.getBoundingClientRect() as DOMRect;
    if (rect.width > 0) {
        let size = Math.floor((rect.width + 20) / 170);
        data.value.pageSize = Math.ceil(20 / size) * size;
    } else {
        data.value.pageSize = 24
    }
}

function onStyleChange(value: string) {
    movieAll.updateStyle(store, value);
}

function onPageChange(page: number) {
    const query = Object.assign({ cid: data.value.childId, order: data.value.order, style: data.value.style }, { page: page })
    context.go(query);
}

function onChildChange(cid: string) {
    const query = Object.assign({ page: data.value.page, order: data.value.order, style: data.value.style }, { cid })
    context.go(query);
}

function onOrderChange(order: string) {
    const query = Object.assign({ page: data.value.page, cid: data.value.childId, style: data.value.style }, { order })
    context.go(query);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "link",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(lang).topMenu.movie), 1)
        ]),
        _: 1
      }),
      _hoisted_3,
      _createElementVNode("span", null, _toDisplayString(_unref(lang).movieMenu.all), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("b", null, _toDisplayString(_unref(lang).movieMenu.all), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("b", null, _toDisplayString(_unref(lang).movieText.filter_view), 1),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          class: _normalizeClass(["link", { on: _unref(data).style == 'album' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onStyleChange('album')))
        }, _toDisplayString(_unref(lang).movieText.filter_view_card), 3),
        _createElementVNode("a", {
          class: _normalizeClass(["link", { on: _unref(data).style == 'text' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onStyleChange('text')))
        }, _toDisplayString(_unref(lang).movieText.filter_view_text), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("b", null, _toDisplayString(_unref(lang).movieText.filter_sort), 1),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          class: _normalizeClass(["link", { on: _unref(data).order == 'addtimeOrder' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onOrderChange('addtimeOrder')))
        }, _toDisplayString(_unref(lang).movieText.filter_sort_add), 3),
        _createElementVNode("a", {
          class: _normalizeClass(["link", { on: _unref(data).order == 'edittimeOrder' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (onOrderChange('edittimeOrder')))
        }, _toDisplayString(_unref(lang).movieText.filter_sort_update), 3),
        _createElementVNode("a", {
          class: _normalizeClass(["link", { on: _unref(data).order == 'recommend' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (onOrderChange('recommend')))
        }, _toDisplayString(_unref(lang).movieText.filter_sort_recommend), 3),
        _createElementVNode("a", {
          class: _normalizeClass(["link", { on: _unref(data).order == 'hitsOrder' }]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (onOrderChange('hitsOrder')))
        }, _toDisplayString(_unref(lang).movieText.filter_sort_hot), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("b", null, _toDisplayString(_unref(lang).movieText.filter_category), 1),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rootData).moviesConfig.categories, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["link", { on: _unref(data).childId == item.id }]),
            onClick: ($event: any) => (onChildChange(item.id))
          }, _toDisplayString(item.name), 11, _hoisted_8))
        }), 256))
      ])
    ]),
    (_unref(data).style == 'album')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "albums",
          ref_key: "container",
          ref: container
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item) => {
            return (_openBlock(), _createBlock(Album, { album: item }, null, 8, ["album"]))
          }), 256))
        ], 512))
      : _createCommentVNode("", true),
    (_unref(data).style == 'text')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "list",
          ref_key: "container",
          ref: container
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, i) => {
            return (_openBlock(), _createBlock(TextAlbum, {
              album: item,
              i: i + 1
            }, null, 8, ["album", "i"]))
          }), 256))
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(Pagination, {
      total: _unref(data).total,
      page: _unref(data).page,
      size: _unref(data).pageSize,
      onChange: onPageChange
    }, null, 8, ["total", "page", "size"])
  ]))
}
}

})